/**
 * EmbedMessage
 */

import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18n';
import classNames from 'classnames';
import _ from 'lodash';
import './EmbedMessage.scss';

const EmbedMessage = ({src, showEmbed, hideMessage}) => {
    // const {t} = useTranslation();

    useEffect(() => {
        // Hide message when cookie script values are changed
        window.addEventListener('CookieScriptAccept', (e) => {
            const categories = _.get(e, 'detail.categories', []);
            if(categories.includes('targeting')) {
                hideMessage();
            }
        });
        window.addEventListener('CookieScriptAcceptAll', () => {
            hideMessage();
        });
    }, []);

    const regExp = /^.*(youtu\.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
    const match = src.match(regExp);
    const videoId = match && match[2].length === 11 ? match[2] : '';
    const url = `https://www.youtube.com/watch?v=${videoId}`;

    const classes = classNames(
        'EmbedMessage',
    );

    return (
        <div className={classes}>
            <div className="EmbedMessage__Content">
                <div
                    className="EmbedMessage__Text"
                    dangerouslySetInnerHTML={{__html: i18n.t('embedMessage.msg')}}
                />

                <button
                    className="EmbedMessage__Button"
                    onClick={() => [
                        hideMessage(),
                        showEmbed(),
                    ]}
                    type="button"
                ><span>{i18n.t('embedMessage.show')}</span></button>

                <a className="EmbedMessage__Link" href={url}>
                    {i18n.t('embedMessage.goTo')}
                </a>
            </div>
        </div>
    );
};

EmbedMessage.propTypes = {
    src: PropTypes.string,
    showEmbed: PropTypes.func,
    hideMessage: PropTypes.func,
};

EmbedMessage.defaultProps = {
    src: '',
    showEmbed: () => {},
    hideMessage: () => {},
};

export default EmbedMessage;
